import { getController } from '@/controllers/request';

export default {
  namespaced: true,
  state: {
    navigationData: {}
  },
  mutations: {
    setNavigationData(state, data) {
      state.navigationData = data;
    }
  },
  actions: {
    async getNavigationData({ commit, rootState }) {
      try {
        const { data } = await getController({
          params: {
            module: 'Home',
            action: 'getHeaderMenuData'
          }
        });
        commit('setNavigationData', data);
        rootState.auth.userId =
          data.profile_button_area[0]?.child[0]?.intents[0]?.request
            ?.request_params?.record || '';
      } catch (error) {
        console.error(error);
      }
    }
  }
};
